import React from "react";

import Cartes from "../../ui/cartes";
import Filtres from "../../ui/filtres";
import Pagination from "../../ui/pagination";
import ListeCategories from "../../ui/listeCategories";
import SearchNoContent from "../../ui/searchNoContent";
import { PUBFORMATS } from "../../ui/pub/formats";

import styles from "./cartes.module.scss";
import { PageItemsWithFilters } from "@/types/contenu";

import Pub from "@/ui/pub";
import { useSearchParams } from "next/navigation";

type CartesLayoutProps = {
    categoryId?: number;
    page?: string;
    term?: string;
    type?: string;
    content: PageItemsWithFilters;
};

const configs = {
    indexPubs: [20, 12, 4],
    pageCount: 24,
};

const CartesLayout = ({ categoryId, page, type, content }: CartesLayoutProps) => {
    const search = useSearchParams();

    const count = parseInt(search.get("count") || "") || configs.pageCount;

    const typeLower = String(type).toLowerCase().trim();

    return (
        <div data-component="CartesLayout" className={styles.me}>
            {typeLower === "recette" && (
                <Filtres filtersCounts={content?.filtres || []} total={content?.count || 0} />
            )}

            {typeLower === "publication" && categoryId && (
                <ListeCategories categoryId={categoryId} />
            )}

            {/* Display if have no content for search page */}
            {(!content?.items || content.items.length === 0) && page === "recherche" && (
                <SearchNoContent />
            )}

            {content?.items && content.items.length > 0 && <Cartes contenus={content.items} />}

            {content?.count > count && <Pagination count={count} total={content.count} />}
            
            <Pub format={PUBFORMATS.leaderboardBillboardDouble} />
        </div>
    );
};

export default CartesLayout;
